// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f989788","453":"459ae14a","732":"98ebb874","825":"9bb9b6fe","977":"05827ca0"}[chunkId] + ".chunk.js";
};